export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_REQUIRED = 'AUTH_REQUIRED';
export const LOGOUT = 'LOGOUT';

const localStorage = window.localStorage;

export const auth = {
  setToken(token) {
    localStorage.setItem('token', token);
  },

  getToken() {
    return localStorage.getItem('token');
  },

  loggedIn() {
    return localStorage.getItem('token') !== null;
  },

  logout() {
    localStorage.removeItem('token');
  },

  havePermissions(user, permissions) {
    if (!permissions || permissions.length === 0) return true;
    if (!user || !user.permissions) return false;
    const permissionsValues = permissions.map(permission =>
      user.permissions.indexOf(permission) > -1,
    );
    const havePermissions = permissionsValues.indexOf(true) > -1;
    return havePermissions;
  },
};

export const authMiddleware = () => next => action => {
  if (action.type === AUTH_SUCCESS) {
    if (action.authInfo && action.authInfo.token) {
      auth.setToken(action.authInfo.token);
    } else {
      auth.logout();
    }
  } else if (action.type === LOGOUT) {
    auth.logout();
  }
  next(action);
};
